// hnb-frontend/src/features/provider-owner/layout/ProviderSetupBanner.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';

const ProviderSetupBanner: React.FC = () => {
  const { user } = useAuth();

  const providerStatus =
    typeof user?.providerStatus === 'string'
      ? user.providerStatus.trim().toLowerCase()
      : '';

  const onboardingCompleted = Boolean(user?.providerOnboardingCompleted);

  const isSetupIncomplete =
    !onboardingCompleted &&
    providerStatus !== 'verified' &&
    providerStatus !== 'live';

  if (!isSetupIncomplete) {
    return null;
  }

  return (
    <div
      style={{
        background: '#fff8e6',
        border: '1px solid #f4d58d',
        borderRadius: 16,
        padding: '1rem 1rem',
        boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04)',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: '1rem',
          flexWrap: 'wrap',
        }}
      >
        <div>
          <p
            style={{
              margin: 0,
              color: '#92400e',
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
            }}
          >
            Setup incomplete
          </p>
          <p
            style={{
              margin: '0.4rem 0 0',
              color: '#78350f',
              fontSize: 15,
              lineHeight: 1.6,
            }}
          >
            Finish onboarding steps before your business can go live on HnB.
            Profile, verification, services, availability, and portfolio should
            reflect the approved provider setup.
          </p>
        </div>

        <Link
          to="/provider/onboarding/start"
          style={{
            textDecoration: 'none',
            background: '#111827',
            color: '#ffffff',
            padding: '0.72rem 1rem',
            borderRadius: 999,
            fontWeight: 700,
            fontSize: 14,
            whiteSpace: 'nowrap',
            boxShadow: '0 10px 18px rgba(15, 23, 42, 0.14)',
          }}
        >
          Resume setup
        </Link>
      </div>
    </div>
  );
};

export default ProviderSetupBanner;